import { HttpHandler, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppFacade } from '../+store/app/app.facade';

@Injectable({
  providedIn: 'root'
})
export class OrganizationInterceptor {
  selectedOrg: string;
  constructor(private appFacade: AppFacade) {
    this.appFacade.selectedLayout$.subscribe(layout => {
      this.selectedOrg = layout ? layout.organization : null;
    });
  }
  intercept(request: HttpRequest<any>, next: HttpHandler) {
    // skip adding organization for login and signup requests

    if (!this.selectedOrg) return next.handle(request);
    const orgRequest = request.clone({
      setHeaders: { organization: this.selectedOrg }
    });
    return next.handle(orgRequest);
  }
}
